import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import FullText from './search_components/FullText';
import Lemma1 from './search_components/Lemma1'
import { makeStyles } from '@material-ui/core/styles';
import UD1 from './search_components/UD1'
import Advanced from './search_components/Advanced'
import Annot3 from "./search_components/Annot3";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


const useStyles = makeStyles((theme) => ({
  block: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0)

  },
  image: {
    maxWidth: '100%',
  },

cent : {

  textAlign: 'center'
},

cont: {
  marginTop: '0'
}
}));


export default function BasicTabs({data}) {

  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
          <Tab style={{fontFamily: 'Arial'}}  label="Fulltext" {...a11yProps(0)} />
          <Tab style={{fontFamily: 'Arial'}}  label="Lemma" {...a11yProps(1)} />
          <Tab  style={{fontFamily: 'Arial'}}  label="PoS Tag" {...a11yProps(2)} />
          <Tab style={{fontFamily: 'Arial'}} label="UD Tag" {...a11yProps(3)} />
          <Tab  style={{fontFamily: 'Arial'}}  label="Advanced" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
     <FullText data={data}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <div
        className={classes.block} >
          <b>Lemma</b> — search tokens by lemma, i.e. basic or dictionary form of the word.
          Nouns are usually given in sg.nom (e.g. <i>slovo</i> 'word'), adjectives in m.sg.nom (e.g. <i>nov</i> 'new'),
          verbs in 1sg.prs (e.g. <i>stana</i> 'stand up').
       </div>
        <Lemma1 data={data}/>
      </TabPanel>
      <TabPanel value={value} index={2}>

      <div
        className={classes.block} >
           <b>PoS Tag</b> — search tokens by tags reflecting part-of-speech category and morphological properties. <br /><br /> Morphological annotation follows the <a href="http://nl.ijs.si/ME/V6/msd/html/msd-bg-dam.html" target='_blank'>MULTEXT-East</a> standard with <a href='https://www.punco.uzh.ch/ref'  rel="noopener noreferrer"  style={{textDecoration: 'none'}}   target='_blank'>minor</a> modifications. <br/>
           The information is provided by a string of characters, reflecting the part-of-speech category (capital) and information marked by the inflection.<br/><br/>
            The strings are specific for each part-of-speech category. <br/>
            For example, <i>slovesa</i> 'words' would be annotated as <b>Nnpnn</b>,
             denoting category as "noun"  and inflection (neutral gender, plural number, default/nominative case, not animated).<br/><br/>

            It is possible to search for a full tag and for a part: for example, the query <b>N</b> will find all the nouns and the query <b>Nf</b> — all the feminine nouns.<br/>
          Also, you can replace a category tag with '?' in order to get any value, e. g. <b>N?sny</b> will return singular animate nouns in nominative of all genders . <br/><br/>

       </div>
        <Annot3 data={data} />

      </TabPanel>
      <TabPanel value={value} index={3}>


      <div
        className={classes.block} >
           <b>UD Tag</b>  — search tokens by syntactic annotation. <br /><br /> Each sentence is syntactically annotated by the <a href="https://universaldependencies.org/u/overview/syntax.html" target='_blank'>Universal Dependencies</a> standard. <br/>
          Each token is given an ID according to the position in the sentence.  <br/> <br/>
        For each token, a dependency on other elements within the sentence is declared by these ids, as well as by the character of the dependency.  <br/> <br/>
         One token in each sentence is marked as its root, usually representing the most verbal element.  <br/> <br/>


       </div>
        <UD1 data={data}/>
      </TabPanel>

      <TabPanel value={value} index={4}>
       <Advanced data={data} />
      </TabPanel>
    </Box>
  );
}


// <a href='http://nl.ijs.si/ME/V6/msd/html/msd-bg-dam.html'>Official damaskini tagset</a>
// <a href='https://www.punco.uzh.ch/ref'>Comparison with PPS</a> <br/> style={{textDecoration: 'none'}}